import { render, staticRenderFns } from "./ResourceLanding.vue?vue&type=template&id=694fabc4"
import script from "./ResourceLanding.vue?vue&type=script&lang=js"
export * from "./ResourceLanding.vue?vue&type=script&lang=js"
import style0 from "./ResourceLanding.vue?vue&type=style&index=0&id=694fabc4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports